export function shouldOmitFieldsForRendering(
    fieldName: string, fieldsToOmit?: string[], omitByExternalLogic?: boolean,
): boolean {
    return Boolean(fieldsToOmit?.includes(fieldName) || omitByExternalLogic);
}
